module.exports = __webpack_public_path__ + "assets/90258f3f1484099bf4518a4f5ae7804e.mp3";